export const getFormattedDate = (date: string) => {
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  const dateToFormat = new Date(date);
  const formattedDate = dateToFormat.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
  });
  if (
    dateToFormat.getDate() === today.getDate() &&
    dateToFormat.getMonth() === today.getMonth() &&
    dateToFormat.getFullYear() === today.getFullYear()
  ) {
    return 'Today';
  } else if (
    dateToFormat.getDate() === yesterday.getDate() &&
    dateToFormat.getMonth() === yesterday.getMonth() &&
    dateToFormat.getFullYear() === yesterday.getFullYear()
  ) {
    return `Yesterday, ${formattedDate}`;
  } else {
    return formattedDate;
  }
};
